import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import WishList from './WishList';
import {
    addToCart,
    getAllWishlists,
    getWishlist,
    deleteWishList,
    updateWishListName,
    deleteWishListItem,
    addAllToCart,
} from '../Services/WishList.service';
import { translate } from '../Services/translation';
import WishListOverview from './WishListOverview';
import Notification from './Notification';

class WishListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            page: 1,
            wishlists: null,
            activeList: '',
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this.setState.wishlists = this.props.getAllWishlists();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleAddAllToCart(wishlistName) {
        this.props.addAllToCart(wishlistName);
    }

    async handleRemoveItem(sortIndex) {
        await this.props.removeItem(sortIndex, this.state.activeList);
        this.props.getListContent(this.state.activeList);
    }

    async handleDeleteWishlist(listName) {
        await this.props.deleteList(listName);
        this.props.getAllWishlists();
        this.setState(() => ({
            activeList: '',
            page: 1,
        }));
    }

    async handleUpdateWishlistName(previousName, newName) {
        await this.props.updateWishlistName(previousName, newName);
        this.props.getAllWishlists();
        this.setState(() => ({
            activeList: '',
            page: 1,
        }));
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            event.target.className !== 'wishlist__icon' &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            this.state.showInfo == true
        ) {
            this.setState(() => ({
                showInfo: false,
                page: 1,
                activeList: '',
            }));
        }
    }

    render() {
        const { wishList } = this.props;
        const { payload } = wishList;

        const onToggle = () => {
            this.setState((prevState) => ({
                showInfo: !prevState.showInfo,
                page: 1,
                activeList: '',
            }));
        };

        return (
            <Fragment>
                <div className="wishlist">
                    <a
                        className="wishlist__link--block"
                        rel="nofollow"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onToggle();
                        }}
                    >
                        <svg
                            width="22"
                            height="20"
                            viewBox="0 0 27 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                id="Vector"
                                d="M23.4826 2.86716C22.8962 2.27522 22.1999 1.80564 21.4336 1.48527C20.6672 1.1649 19.8458 1 19.0163 1C18.1868 1 17.3654 1.1649 16.599 1.48527C15.8327 1.80564 15.1364 2.27522 14.55 2.86716L13.3329 4.09508L12.1159 2.86716C10.9314 1.67203 9.32478 1.00062 7.64958 1.00062C5.97439 1.00062 4.3678 1.67203 3.18326 2.86716C1.99872 4.06229 1.33325 5.68323 1.33325 7.37339C1.33325 9.06356 1.99872 10.6845 3.18326 11.8796L4.40031 13.1075L13.3329 22.12L22.2656 13.1075L23.4826 11.8796C24.0693 11.288 24.5347 10.5855 24.8523 9.81227C25.1698 9.03907 25.3333 8.21033 25.3333 7.37339C25.3333 6.53645 25.1698 5.70771 24.8523 4.93452C24.5347 4.16133 24.0693 3.45883 23.4826 2.86716Z"
                                stroke="var(--navigation-icon-color, #FFFFFF)"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <span className="hide">
                            {translate('wishlist.hiddentitle')}
                        </span>
                    </a>
                    <div
                        className={`wishlist__info 
                ${
                    !this.state.showInfo
                        ? 'wishlist__info--hidden'
                        : 'wishlist__info--visible'
                }`}
                    >
                        <div
                            className="wishlist__content"
                            ref={this.setWrapperRef}
                        >
                            <div className="wishlist__content__top">
                                {this.state.activeList == '' ? (
                                    <p className="wishlist__content__top__title">
                                        {translate('wishlist.title')}
                                    </p>
                                ) : (
                                    <a
                                        className="wishlist__content__top__title wishlist__content__top__title--link"
                                        onClick={() => {
                                            this.setState(() => ({
                                                activeList: '',
                                                page: 1,
                                            }));
                                        }}
                                    >
                                        {this.state.activeList}
                                    </a>
                                )}

                                <span
                                    className="wishlist__content__top__close-button"
                                    onClick={() => onToggle()}
                                    onKeyDown={(e) =>
                                        e.code == 'Enter' && onToggle()
                                    }
                                    tabIndex="0"
                                ></span>
                            </div>
                            {payload && payload.addToCart && (
                                <Notification
                                    text={payload.addToCart.message}
                                    info
                                />
                            )}
                            {payload && payload.addAllToCart && (
                                <Notification
                                    text={payload.addAllToCart.message}
                                    info
                                />
                            )}
                            {payload && payload.success == false && (
                                <Notification text={payload.message} />
                            )}
                            {this.state.page == 1 ? (
                                <WishListOverview
                                    wishList={wishList.lists}
                                    edit={
                                        this.state.activeList == ''
                                            ? false
                                            : true
                                    }
                                    onGoToList={(listName) => {
                                        this.setState(() => ({
                                            page: 2,
                                        }));
                                        this.props.getListContent(listName);
                                    }}
                                    onDeleteList={(listName) => {
                                        this.handleDeleteWishlist(listName);
                                    }}
                                    onUpdateActiveList={(listName) => {
                                        this.setState(() => ({
                                            activeList: listName,
                                        }));
                                    }}
                                    onEditList={(listName) => {
                                        this.setState(() => ({
                                            activeList: listName,
                                        }));
                                    }}
                                    onUpdateWishlistName={(
                                        previousName,
                                        newName
                                    ) => {
                                        this.handleUpdateWishlistName(
                                            previousName,
                                            newName
                                        );
                                    }}
                                />
                            ) : (
                                <>
                                    <WishList
                                        wishList={wishList.list}
                                        onAddToCart={(
                                            articleNumber,
                                            quantity
                                        ) =>
                                            this.props.addToCart(
                                                articleNumber,
                                                quantity
                                            )
                                        }
                                        onRemoveItem={(articleId) => {
                                            this.handleRemoveItem(articleId);
                                        }}
                                    />
                                    <div className="wishlist__sum">
                                        <div className="wishlist__sum__add-to-cart">
                                            <button
                                                className="button wishlist__sum__add-to-cart__button"
                                                onClick={() => {
                                                    this.handleAddAllToCart(
                                                        this.state.activeList
                                                    );
                                                }}
                                            >
                                                {translate(
                                                    'wishlist.addalltocart'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        wishList: state.wishList,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllWishlists: () => dispatch(getAllWishlists()),
        deleteList: (listName) => dispatch(deleteWishList(listName)),
        updateWishlistName: (previousName, newName) =>
            dispatch(updateWishListName(previousName, newName)),
        removeItem: (articleId, wishlistName) =>
            dispatch(deleteWishListItem(articleId, wishlistName)),
        addToCart: (articleNumber, quantity) =>
            dispatch(addToCart(articleNumber, quantity)),
        addAllToCart: (wishlistName) => dispatch(addAllToCart(wishlistName)),
        getListContent: (listName) => dispatch(getWishlist(listName)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WishListContainer);
